import ProductSpecificationDescription, {
    ProductDetailsDescriptionStyles,
} from "@gaiaProfessionals/Components/HCP/ProductSpecificationDescription";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    extendedStyles?: ProductDescriptionStyles;
    showDescription?: boolean;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    wrapper?: InjectableCss;
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyPresentationProps;
    specDescriptionStyles?: ProductDetailsDescriptionStyles;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    specDescriptionStyles: {
        highlightsWrapper: {
            css: css`
                margin-bottom: 0px;
                .product_highlights {
                    list-style: disc;
                    padding: 0 0 0 14px;
                }
            `,
        },
        descriptionWrapper: {
            css: css`
                margin-bottom: 0px;
            `,
        },
    },
    productDetailLink: {
        css: css`
            width: 100%;
            /* margin-bottom: 10px; */
        `,
        typographyProps: {
            css: css`
                width: 100%;
                margin-bottom: 10px;
                ${wrapInContainerStyles}
            `,
        },
    },
};

const ProductDescription: FC<Props> = ({ product, extendedStyles, showDescription }) => {
    const [styles] = React.useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;

    const content = "product" in product ? product.product.content : undefined;
    const specifications = "product" in product ? product.product.specifications : undefined;
    return productDetailPath && (!("isActiveProduct" in product) || product.isActiveProduct) ? (
        <StyledWrapper {...styles.wrapper}>
            <Link
                {...styles.productDetailLink}
                href={productDetailPath}
                aria-label={`See product details for ${description}`}
                data-test-selector="productDescriptionLink"
            >
                {description}
            </Link>
            {showDescription && (
                <ProductSpecificationDescription
                    content={content}
                    specifications={specifications}
                    extendedStyles={styles.specDescriptionStyles}
                />
            )}
        </StyledWrapper>
    ) : (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.productDetailDescription}>{description}</Typography>
            {showDescription && (
                <ProductSpecificationDescription
                    content={content}
                    specifications={specifications}
                    extendedStyles={styles.specDescriptionStyles}
                />
            )}
        </StyledWrapper>
    );
};

export default ProductDescription;
